(() => {
  class BmiHistoryController {
    constructor($scope, Constants) {
      'ngInject';

      Object.assign(this, {
        $scope,
        Constants,
        bmiData: $scope.ngDialogData.bmiData,
        dateDirection: null,
        bmiDirection: null,
        weightUnit: 'metric',
        heightUnit: 'metric'
      });
    }

    toggleDateSortOrder = function(direction) {
      this.dateDirection = direction;
      this.bmiDirection = null;
      this.bmiData.sort(function(a, b) {
        return direction === 'asc' ? new Date(a.date) - new Date(b.date) : new Date(b.date) - new Date(a.date)
      });
    };

    toggleHeightUnit = function(unit) {
      this.heightUnit = unit;
    }

    toggleWeightUnit = function(unit) {
      this.weightUnit = unit;
    }

    //TODO: Harold - check if needed...
    toggleBmiSortOrder = function(direction) {
      this.bmiDirection = direction;
      this.dateDirection = null;
      this.bmiData.sort(function(a, b) {
        return direction === 'asc' ? a.bmi - b.bmi : b.bmi - a.bmi
      });
    }

    convertUnitToImperial(metricValue, type) {
      const conversionRate = type === 'weight' ? this.Constants.UnitConversionRate.STONE_TO_KILOGRAM_CONVERSION_RATE : this.Constants.UnitConversionRate.CM_TO_INCH_CONVERSION_RATE
      if (type === 'weight') {
        const totalStones = metricValue / conversionRate;
        const stones = Math.floor(totalStones);
        const pounds = Math.round((totalStones - stones) * 14);
        return `${stones}st ${pounds}lb`;
      } else if (type === 'height') {
        const totalInches = metricValue * conversionRate;
        const feet = Math.floor(totalInches / 12);
        const inches = Math.round(totalInches % 12);
        return `${feet}ft ${inches}in`;
      }
    }
  }

  BmiHistoryController.$inject = ["$scope", "Constants"]
  angular.module('pims').controller('BmiHistoryController', BmiHistoryController);
})();
